import { TrackingEvent } from '@hakimo-ui/hakimo/types';
import { trackEvent } from '@hakimo-ui/hakimo/util';
import { useCallback } from 'react';
import { useAlarmGroupStatic } from './alarm-provider/AlarmGroupProvider';

export function useAlarmGroupTracking() {
  const { alarmGroupId, product } = useAlarmGroupStatic();
  return useCallback(
    (event: TrackingEvent, extra?: Record<string, unknown>) =>
      trackEvent(event, { alarmGroupId, product, ...extra }),
    [alarmGroupId, product]
  );
}
